import { render, staticRenderFns } from "./MusicCover.vue?vue&type=template&id=b90c55b0&scoped=true&"
import script from "./MusicCover.vue?vue&type=script&lang=js&"
export * from "./MusicCover.vue?vue&type=script&lang=js&"
import style0 from "./MusicCover.vue?vue&type=style&index=0&id=b90c55b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90c55b0",
  null
  
)

export default component.exports